import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=3baa7362&scoped=true&"
import script from "./noData.vue?vue&type=script&lang=js&"
export * from "./noData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa7362",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3baa7362')) {
      api.createRecord('3baa7362', component.options)
    } else {
      api.reload('3baa7362', component.options)
    }
    module.hot.accept("./noData.vue?vue&type=template&id=3baa7362&scoped=true&", function () {
      api.rerender('3baa7362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/noData.vue"
export default component.exports